import type { RouteRecordRaw } from 'vue-router'
import {
  goalRouteCandidates,
  toAnyPermission,
} from '@/config/businessRoutePermissions'
import { legacyTenantRedirect, maybeRouteName } from './tenantScoped'

const createGoalChildren = (withNames: boolean): RouteRecordRaw[] => [
  {
    path: 'okr',
    ...maybeRouteName(withNames, 'okr-management'),
    component: () => import('@/views/goal/OKRManagement.vue'),
    meta: { permission: 'goal:okr:view' }
  },
  {
    path: 'weekly',
    ...maybeRouteName(withNames, 'weekly-goals'),
    component: () => import('@/views/goal/WeeklyGoalManagement.vue'),
    meta: { permission: 'goal:record:view' }
  },
  {
    path: 'daily',
    ...maybeRouteName(withNames, 'daily-goals'),
    component: () => import('@/views/goal/DailyGoalManagement.vue'),
    meta: { permission: 'goal:record:view' }
  },
  {
    path: 'review',
    ...maybeRouteName(withNames, 'okr-review'),
    component: () => import('@/views/goal/OKRReviewList.vue'),
    meta: { permission: 'goal:okr:view' }
  },
  {
    path: 'review/:id',
    ...maybeRouteName(withNames, 'okr-review-detail'),
    component: () => import('@/views/goal/OKRReviewDetail.vue'),
    meta: { permission: 'goal:okr:view' }
  },
  {
    path: 'dashboard',
    ...maybeRouteName(withNames, 'goal-dashboard'),
    component: () => import('@/views/goal/GoalDashboard.vue'),
    meta: { permission: 'goal:record:view' }
  }
]

const createGoalRoute = (path: string, defaultRouteBasePath: string, withNames: boolean): RouteRecordRaw => ({
  path,
  component: () => import('@/views/goal/GoalLayout.vue'),
  ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
  meta: {
    permission: toAnyPermission(goalRouteCandidates),
    defaultRouteBasePath,
    defaultRouteCandidates: goalRouteCandidates,
    ...(!withNames ? { legacyTenantRedirect: true } : {}),
  },
  children: createGoalChildren(withNames)
})

const goalRoutes: RouteRecordRaw[] = [
  createGoalRoute('t/:tenantCode/goals', '/t/:tenantCode/goals', true),
  createGoalRoute('goals', '/goals', false),
]

export default goalRoutes
